var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntegrationCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 39,
    fill: "#013232"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.25 34.1925C50.1167 28.3706 45.0667 24 39 24C34.1833 24 30 26.7675 27.9167 30.8175C22.9 31.3575 19 35.6606 19 40.875C19 46.4606 23.4833 51 29 51H50.6667C55.2667 51 59 47.22 59 42.5625C59 38.1075 55.5833 34.4963 51.25 34.1925ZM50.6667 47.625H29C25.3167 47.625 22.3333 44.6044 22.3333 40.875C22.3333 37.1456 25.3167 34.125 29 34.125H30.1833C31.2833 30.2269 34.8 27.375 39 27.375C44.0667 27.375 48.1667 31.5262 48.1667 36.6562V37.5H50.6667C53.4333 37.5 55.6667 39.7613 55.6667 42.5625C55.6667 45.3638 53.4333 47.625 50.6667 47.625Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationCircle);
export default __webpack_public_path__ + "static/media/integration-circle.f47bb194760dc7f23a4b1878df66ff5f.svg";
export { ForwardRef as ReactComponent };